import {DateTime} from "luxon";
import type {Iso8601DateTime} from "@vesta/common-type-definitions/typeDefinitions";

/** Rolling window length for default date-range filters (dashboard, data viewer, etc.). */
export const DEFAULT_DATE_RANGE_DAYS = 30;

/**
 * Default date range: last {@link DEFAULT_DATE_RANGE_DAYS} days (start of day) through now.
 */
export function getDefaultLast30DaysDateRangeIsoBounds(): {
    start: Iso8601DateTime;
    end: Iso8601DateTime;
} {
    const start = DateTime.now().minus({days: DEFAULT_DATE_RANGE_DAYS}).startOf("day").toISO();
    const end = DateTime.now().toISO();
    return {start: start as Iso8601DateTime, end: end as Iso8601DateTime};
}

/** Current calendar month from its first day through now. */
export function getDefaultThisMonthDateRangeIsoBounds(): {
    start: Iso8601DateTime;
    end: Iso8601DateTime;
} {
    const now = DateTime.now();
    const start = now.startOf("month").toISO();
    const end = now.toISO();
    return {start: start as Iso8601DateTime, end: end as Iso8601DateTime};
}

/** @deprecated Prefer {@link getDefaultLast30DaysDateRangeIsoBounds}. */
export function getDefaultOneMonthDateRangeIsoBounds(): {
    start: Iso8601DateTime;
    end: Iso8601DateTime;
} {
    return getDefaultLast30DaysDateRangeIsoBounds();
}
